<template>
  <div class="myorder">
    <cube-page type="myorder-view" title="收益明细">
      <div slot="content">
        <van-empty
          v-if="isNoData"
          class="custom-image"
          image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
          description="您还没有相关收益明细"
        />
        <van-list v-else
          class="leoshop-content"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad(0)"
          :immediate-check="false"
        >
          <div class="orderitem" v-for="(item, idx) in OrderList" :key="idx">
            <van-cell-group>
              <van-cell title="订单号" :value="item.order_no"/>
              <van-cell title="产品名称" :value="item.goods_name"/>
              <van-cell title="类型" :value="item.type_text"/>
              <van-cell title="状态" :value="item.status_text"/>
              <van-cell :title="item.createtime" icon="clock-o">
                <!-- 使用 right-icon 插槽来自定义右侧图标 -->
                <template #right-icon>
                  <span style="font-size: 12px; padding-right: 5px;">￥</span>
                  <span style="color: #ff0000;font-size: 16px;font-weight: 600;">{{item.amount}}</span>
                </template>
              </van-cell>
            </van-cell-group>
          </div>
        </van-list>
      </div>
    </cube-page>
    <cube-view></cube-view>
  </div>
</template>

<script>
import CubeView from "@/components/TP/cube-view";
import CubePage from "../TP/cube-page.vue";
import * as util from "@/utils/network";

export default {
  components: {
    CubePage,
    CubeView
  },
  data() {
    return {
      loading: false,
      finished: false,
      OrderList: [],
      active: this.$route.query.showType,
      isNoData: false,
      gcfg: [],
      store: null,
      pageIndex: 1,
      pageTotal: 0
    };
  },
  created() {
    this.gcfg = this.$store.getters.getGcfg;
    this.store = this.$store.getters.getShop;
    this.get_my_order();
  },
  methods: {
    onLoad(index) {
      let that = this;
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求	// 异步更新数据
      that.pageIndex++;
      setTimeout(() => {
        that.get_my_order();
      }, 1000);
    },
    get_my_order() {
      var url = "/addons/litestore/api.store/incomeList";
      let that = this;
      console.log(that.store);
      //这里直接调用网络接口
      util.get(
        url,
        {
          page: that.pageIndex,
          store_id: that.store
        },
        function(result) {
          //这里对状态 进行分类
          that.loading = false;
          //这里对状态 进行分类
          that.pageTotal = result.data.total;
          if (that.pageTotal < 1) {
            that.isNoData = true;
            return;
          }
          if (result.data.list == null || result.data.list.length === 0) {
            // 加载结束
            that.finished = true;
            return;
          }
          // 将新数据与老数据进行合并
          that.OrderList = that.OrderList.concat(result.data.list);

          //如果列表数据条数>=总条数，不再触发滚动加载
          if (that.OrderList.length >= that.pageTotal) {
            that.finished = true;
          }
        }
      );
    }
  },
  watch: {
    "$store.state.gcfg"() {
      this.gcfg = this.$store.getters.getGcfg;
    },
    "$store.state.shop"() {
      this.store = this.$store.getters.getShop;
    }
  }
};
</script>
<style lang="less" scoped="scoped">
@import url("../../assets/css/order.css");
</style>
